module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.deleted) ? _c('div', {
    staticClass: "redirect-item columns"
  }, [_c('div', {
    staticClass: "centered column delete-column"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.handleDelete
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите исходный URL",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.redirect.fromUrl),
      callback: function($$v) {
        _vm.$set(_vm.redirect, "fromUrl", $$v)
      },
      expression: "redirect.fromUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите целевой URL",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.redirect.toUrl),
      callback: function($$v) {
        _vm.$set(_vm.redirect, "toUrl", $$v)
      },
      expression: "redirect.toUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered column edit edit-column"
  }, [(!_vm.editMode) ? _c('img', {
    staticClass: "edit-icon",
    attrs: {
      "src": "/static/img/icons/edit.svg"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }) : _c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.handleUpdateRedirect
    }
  }, [_vm._v("Сохранить")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07754f69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Redirects/RedirectItem.vue
// module id = 888
// module chunks = 0